import React, { useEffect, useState } from 'react';

export const ScrollToTopIcon = () => {
    const [visible, setVisible] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    const toggleVisibility = () => {
        if (window.scrollY > 150)
            setVisible(true)
        else setVisible(false)
    }

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility)
    }, [])

    return (
        <div className='scroll-to-top'>
            {
                visible &&
                <div className='button-container' onClick={scrollToTop}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m6 15l6-6l6 6" /></svg>
                </div>
            }
        </div>
    )
}